import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../globals';
import { FormGroup } from '@angular/forms';


//interface
interface Product {
  UID: string;
  UID_RESTAURANT: string;
  allergens: object;
  measurement: string;
  name: string;
  name_ca: string;
  name_en: string;
  name_de: string;
  name_fr: string;
  name_it: string;
  price_static: number;
  provider_static: string;
  providers: object;
  stock: number;
  stock_alert: number;
  stock_max: number;
  sub_recipe: boolean;
  tags: object;
  tags_static: string;
  tax: number;
  foodcost: object;
  real_weight: number;
  recipe: string;
  time: string;
  tools: string;
  image: string;
  pvp: number;
  pvp2: number;
  pvp3: number;
  pvp_combo_extra: number;
  pvp_supplement: number;
  pvp_takeaway: number;
  description_es: string;
  description_ca: string;
  description_en: string;
  description_de: string;
  description_fr: string;
  description_it: string;
  tpv_active: boolean;
  pos_favourite: boolean;
  variations_favourite: object;
}

interface Ingredient {
  UID: string;
  UID_RESTAURANT: string;
  allergens: object;
  measurement: string;
  name: string;
  price_static: number;
  provider_static: string;
  providers: object;
  stock: number;
  stock_alert: number;
  stock_max: number;
  sub_recipe: boolean;
  tags: object;
  tags_static: string;
  tax: number;
  foodcost: object;
  real_weight: number;
  recipe: string;
  time: string;
  tools: string;
  image: string;

}

interface List {
  UID: string;
  UID_RESTAURANT: string;
  allergens: object;
  measurement: string;
  name: string;
  name_ca: string;
  name_en: string;
  name_de: string;
  name_fr: string;
  name_it: string;
  price_static: number;
  provider_static: string;
  providers: object;
  stock: number;
  stock_alert: number;
  stock_max: number;
  sub_recipe: boolean;
  tags: object;
  tags_static: string;
  tax: number;
  foodcost: object;
  real_weight: number;
  recipe: string;
  time: string;
  tools: string;
  image: string;
  pvp: number;
  type: string;
  values: object;
  description_es: string;
  description_ca: string;
  description_en: string;
  description_de: string;
  description_fr: string;
  description_it: string;
}


@Injectable()
export class ProductsServices {


  public product_tmp: Product = {
    UID: '',
    UID_RESTAURANT: '',
    allergens: [],
    measurement: '',
    name: '',
    name_ca: '',
    name_en: '',
    name_de: '',
    name_fr: '',
    name_it: '',
    price_static: 0,
    provider_static: '',
    providers: [],
    stock: 0,
    stock_alert: 0,
    stock_max: 0,
    sub_recipe: false,
    tags: [],
    tags_static: '',
    tax: 0,
    foodcost: [],
    real_weight: 0,
    recipe: '',
    time: '',
    tools: '',
    image: '',
    pvp: 0,
    pvp2: 0,
    pvp3: 0,
    pvp_combo_extra: 0,
    pvp_supplement: 0,
    pvp_takeaway: 0,
    description_es: '',
    description_ca: '',
    description_en: '',
    description_de: '',
    description_fr: '',
    description_it: '',
    tpv_active: true,
    pos_favourite: false,
    variations_favourite: []
  };


  public firestore: any;
  public image_url_product_view: Observable<string | null>;
  productCol: AngularFirestoreCollection<Product>;
  products: Observable<Product[]>;
  productDoc: AngularFirestoreDocument<Product>;
  product: Observable<Product[]>;
  products_variations: Observable<Product[]>;
  products_stock: Observable<Product[]>;

  ingredientsCol: AngularFirestoreCollection<Ingredient>;
  ingredientsCol_subrecipe: AngularFirestoreCollection<Ingredient>;
  ingredients: Observable<Ingredient[]>;

  listing: Observable<List[]>;
  listprod: Observable<List[]>;
  //list: Observable<List[]>;

  public list_array_tmp = Array();
  public liststockmax_array_tmp = Array();
  public liststockmin_array_tmp = Array();
  public prodings_array_tmp = Array();

  //deleteStat: boolean = false;

  //TMP - Son variables a utilizar en diferentes puntos de la creacio/edicion para enviar modificar la informacion de diferentes componentes
  public foodcost_array_tmp: any = Array();
  public products_array_tmp: any = Array();
  public product_tags = Array();
  public products_allergens_tmp: any = Array();
  public quick_create: boolean = false;
  public quick_create_type: boolean = false;

  public provider_products_array_tmp = Array();

  public pagesProducts: any;
  public page_active: number = 1;
  public limit_pages = 100;
  public first_product_name: any = [];
  public get_products_done: boolean = false;

  public _products_array_tmp: any;
  public products_array: any;

  public show_alert_delete: boolean = true;

  //hacer form publico para usarlo en componentes
  public form: FormGroup;

  constructor(public afs: AngularFirestore,
    public http: HttpClient,
    public globals: Globals) {
    this.firestore = firebase.firestore();
  }

  getListProducts(UID_RESTAURANT) {
    this.productCol = this.afs.collection('products', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('name', 'asc'));
    this.products = this.productCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Product;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  /*GET IN STOCK*/
  getListProductsBasic(UID_RESTAURANT) {
    this.productCol = this.afs.collection('products', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).where('sub_recipe', '==', false));
    this.products_stock = this.productCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Product;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  /*GET IN CONF. VARIATIONS*/
  getListProductsVariations(UID_RESTAURANT) {
    this.productCol = this.afs.collection('products', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .orderBy('name', 'asc'));
    this.products_variations = this.productCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Product;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  /*PRODING*/
  // ✅ Subscription para getListPartialSelect
  private listingSubscription: any;
  getListPartialSelect(UID_RESTAURANT) {
    // ✅ LIMPIAR SOLO los arrays que se usan en esta función
    this.list_array_tmp = [];

    // ✅ Limpiar subscription anterior si existe
    if (this.listingSubscription) {
      this.listingSubscription.unsubscribe();
    }

    this.ingredientsCol = this.afs.collection('ingredients', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .orderBy('name', 'asc'));
    this.listing = this.ingredientsCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as List;
        data.UID = a.payload.doc.id;
        data.type = "ingredient";
        return data;
      });
    });

    this.listingSubscription = this.listing.subscribe(docs => {
      docs.forEach(doc => {
        this.list_array_tmp.push(doc);
      });
    });


    /*this.productCol = this.afs.collection('products', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('sub_recipe', '==', false)
      .orderBy('name', 'asc'));
    this.listprod = this.productCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as List;
        data.UID = a.payload.doc.id;
        data.type = "product";
        return data;
      });
    });

    this.listprod.subscribe(docs => {
      docs.forEach(doc => {
        this.list_array_tmp.push(doc);
      })
    });*/


  }




  async getProducts(UID_RESTAURANT) {
    const productsRef = this.firestore.collection('products');

    var products = [];

    await productsRef.where('UID_RESTAURANT', '==', UID_RESTAURANT).get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var product = doc.data();
          product.UID = doc.id;

          products.push(product);
        });
      });

    return products
  }

  async getProductsBasic(UID_RESTAURANT) {
    const productsRef = this.firestore.collection('products');

    var products = [];

    await productsRef
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('sub_recipe', '==', false)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var product = doc.data();
          product.UID = doc.id;

          products.push(product);
        });
      });

    return products
  }

  async getProductsCompost(UID_RESTAURANT) {
    const productsRef = this.firestore.collection('products');

    var products = [];

    await productsRef
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('sub_recipe', '==', true)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var product = doc.data();
          product.UID = doc.id;

          products.push(product);
        });
      });

    return products
  }

  async getProduct(uid) {
    const ingProd = this.firestore.collection('products').doc(uid);

    var _prod;

    await ingProd.get().then(doc => {
      if (doc.exists) {
        _prod = doc.data();
        _prod.UID = doc.id;
      }
    });

    return _prod

  }


  delete(uid) {
    this.afs.doc('products/' + uid).delete();
  }

  public filteredProducts: any;
  public filteredProductsActive: boolean = false;

  searchProductNode(value, type) {
    if (value.target.value == '' || value.target.value == undefined) {
      this.filteredProductsActive = false;
    } else {
      if (value.target.value.length >= 3) {
        const params = new HttpParams()
          .set('uid', this.globals.restaurant_uid)
          .set('type', type)
          .set('filter_string', value.target.value.toLowerCase());
        this.http.post(this.globals.analytics_path + 'filter/product', params, {})
          .subscribe(async res => {
            this.filteredProducts = res;
            this.filteredProductsActive = true;
          });
      } else {
        this.filteredProductsActive = false;
      }
    }
  }

  first_element: any;

  //PAGINATE
  async getPagesProducts(type, elements_per_page) {
    this.get_products_done = false;
    this.filteredProductsActive = false;
    this.limit_pages = elements_per_page;

    // ✅ LIMPIAR SOLO los arrays que se usan DENTRO de esta función
    this._products_array_tmp = [];
    this.products_array = [];
    this.first_product_name = [];
    this.pagesProducts = [];

    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('type', type)
      .set('elements_per_page', elements_per_page);
    await this.http.post(this.globals.analytics_path + 'paginate/product', params, {})
      .subscribe(async res => {
        this.pagesProducts = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
        this.first_product_name = res['first_products_name'];
        this._products_array_tmp = res['list_products'];
        if (this.pagesProducts != 0) {
          this.getListProductsMinMax();
        } else {
          this.filteredProductsActive = true;
        }
      });
  }

  getListProductsMinMax() {
    this.get_products_done = true;

    //Ordenamos el array
    this._products_array_tmp.sort((a, b) => this.globals.nameLangSelectProduct(a).localeCompare(this.globals.nameLangSelectProduct(b)));

    //Search for first element to start
    this.first_element = (this.page_active - 1) * this.limit_pages;
    //We slice the array with the first element, and the first element plus the limit to get the last index
    if (this.limit_pages > 0) {
      this.products_array = this._products_array_tmp.slice(this.first_element, this.first_element + this.limit_pages);
    } else {
      this.products_array = this._products_array_tmp;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/products/services.ts